export const setDocumentTitle = (title: string): void => {
    document.title = `${title} | Bouygues Telecom`;
};

export const replaceWindowUrl = (url: string): void => {
    window.history.replaceState({}, '', url);
};

export const scrollToHash = (): void => {
    const hash = window.location.hash;
    if (hash) {
        document.querySelector(window.location.hash)?.scrollIntoView({ behavior: 'smooth' });
    }
};
